/**
 * Vararuci's 248 candravakyas: the Moon's true longitude at mean sunrise on each
 * day of the 248-day cycle (nine anomalistic revolutions), in arcminutes.
 *
 * Source: Vakyakarana, ed. T. S. Kuppanna Sastri and K. V. Sarma, Kuppuswami
 * Sastri Research Institute, Madras 1962, Appendix II (Candravakyani,
 * vararucikrtani), pp. 125-34.
 *
 * The edition supplies its own checksum - V(n) + V(248-n) = V(248) = 0r 27deg 44'
 * for every n, and V(124) is six rasis plus half of V(248) - and every pair holds
 * on these values.
 *
 * Indexed from 1, so entry 0 is the empty remainder - the dhruva with no vakya
 * added.
 */
export const CANDRAVAKYAS: readonly number[] = [
    0, 723, 1449, 2182, 2924, 3679, 4449, 5233, 6033, 6849, 7678, 8518, 9368,
    10225, 11084, 11942, 12795, 13642, 14477, 15301, 16109, 16902, 17680, 18443,
    19192, 19930, 20659, 21384, 506, 1230, 1958, 2695, 3443, 4204, 4980, 5772,
    6579, 7401, 8235, 9080, 9933, 10791, 11650, 12507, 13357, 14199, 15030,
    15847, 16649, 17435, 18206, 18962, 19706, 20440, 21166, 289, 1012, 1738,
    2470, 3211, 3965, 4732, 5515, 6314, 7127, 7955, 8794, 9644, 10499, 11358,
    12216, 13071, 13918, 14755, 15580, 16390, 17185, 17964, 18728, 19479, 20218,
    20948, 73, 795, 1519, 2247, 2983, 3730, 4489, 5263, 6053, 6858, 7678, 8512,
    9356, 10208, 11066, 11925, 12782, 13633, 14477, 15308, 16127, 16930, 17718,
    18491, 19248, 19994, 20728, 21456, 579, 1301, 2026, 2758, 3498, 4250, 5016,
    5797, 6594, 7406, 8232, 9071, 9919, 10774, 11632, 12490, 13345, 14193,
    15032, 15858, 16670, 17467, 18248, 19014, 19766, 20506, 21238, 363, 1085,
    1808, 2536, 3270, 4016, 4773, 5546, 6334, 7137, 7956, 8787, 9631, 10482,
    11339, 12198, 13056, 13908, 14752, 15586, 16406, 17211, 18001, 18775, 19534,
    20281, 21017, 145, 869, 1591, 2316, 3046, 3785, 4536, 5300, 6079, 6874,
    7684, 8509, 9346, 10193, 11048, 11906, 12765, 13620, 14470, 15309, 16137,
    16950, 17749, 18532, 19299, 20053, 20794, 21526, 652, 1375, 2098, 2824,
    3558, 4302, 5058, 5829, 6615, 7417, 8234, 9065, 9907, 10757, 11614, 12473,
    13331, 14184, 15029, 15863, 16685, 17492, 18284, 19060, 19821, 20569, 21306,
    434, 1158, 1880, 2605, 3334, 4072, 4821, 5584, 6362, 7155, 7963, 8787, 9622,
    10469, 11322, 12180, 13039, 13896, 14746, 15586, 16415, 17231, 18031, 18815,
    19585, 20340, 21082, 215, 941, 1664,
];

/** V(248), the Moon's gain over a full cycle beyond nine revolutions. */
export const CANDRAVAKYA_TOTAL = CANDRAVAKYAS[248];
